interface ColorProps {
	category: string[];
	service: string[];
}

export const colors: ColorProps = {
	category: ['#FFEDED', '#FFDBDB', '#FFC8C8', '#FFB6B6', '#FFA4A4', '#FF9292'],
	service: ['#EDEDFF', '#DBDBFF', '#C8C8FF', '#B6B6FF', '#A4A4FF', '#9292FF'],
};
